import { QText } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../../containers/confirmation-modal';
import { ModalComponentProps } from '../../../types';

type DeleteUserConfirmationProps = ModalComponentProps & {
  removeUser: () => void;
  isDeleting: boolean;
  name: string;
};

export const DeleteUserConfirmation = ({ closeModal, removeUser, isDeleting, name }: DeleteUserConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      data-cy="heading"
      closeModal={closeModal}
      title={t('modals.removeUser.title')}
      size="lg"
      cancelLabel={t('common.no')}
      buttonProps={{
        type: 'button',
        label: t('modals.removeUser.yesRemoveUser'),
        isDestructive: true,
        onClick: removeUser,
        isLoading: isDeleting,
      }}
    >
      <QText>{t('modals.removeUser.confirmMessage', { name })}</QText>
    </ConfirmationModal>
  );
};
